export default {
      id: "visitor-usage",
      viewBox: "0 0 162 162",
      url: __webpack_public_path__ + "sprite.svg#visitor",
      toString: function () {
        return this.url;
      }
    }